import React from "react";

const SocialIcons = () => {
  return (
    <div className="flex items-center gap-3">
      {/* Instagram */}
      <div className="social-button">
        <a
          href="https://www.instagram.com/scanglobalholdings?igsh=MWN4enN3MDM5dG5hYg=="
          target="_blank"
          rel="noopener noreferrer"
          className="relative w-10 h-10 sm:w-11 sm:h-11 rounded-full group flex items-center justify-center"
        >
          <div className="floater w-full h-full absolute top-0 left-0 bg-gold/10 backdrop-blur-md rounded-full duration-300 group-hover:-top-8 group-hover:shadow-2xl sm:group-hover:-top-8 sm:group-hover:shadow-2xl" />
          <div className="icon relative z-10 w-full h-full flex items-center justify-center border-2 border-gold rounded-full cursor-pointer">
            <svg
              fill="none"
              viewBox="0 0 22 22"
              height={20}
              width={20}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.94 6.46809C21.8884 5.2991 21.6994 4.49551 21.4285 3.79911C21.1492 3.05994 20.7194 2.39818 20.1564 1.84802C19.6062 1.28932 18.9401 0.855163 18.2094 0.580194C17.5091 0.309437 16.7096 0.120336 15.5407 0.0688497C14.363 0.0128932 13.9891 0 11.0022 0C8.01527 0 7.64141 0.0128932 6.46808 0.064466C5.29914 0.116039 4.49551 0.305225 3.79932 0.57581C3.05994 0.855163 2.39818 1.28494 1.84802 1.84802C1.28932 2.39813 0.855377 3.06428 0.580193 3.7949C0.309437 4.49551 0.120379 5.2948 0.0688496 6.4637C0.0129362 7.64141 0 8.01527 0 11.0022C0 13.9891 0.0129362 14.363 0.0644659 15.5363C0.116039 16.7053 0.305225 17.5089 0.576025 18.2053C0.855377 18.9444 1.28932 19.6062 1.84802 20.1564C2.39818 20.7151 3.06432 21.1492 3.79494 21.4242C4.49547 21.6949 5.29476 21.884 6.46391 21.9355C7.63702 21.9873 8.0111 22 10.998 22C13.9849 22 14.3588 21.9873 15.5321 21.9355C16.7011 21.884 17.5047 21.695 18.2009 21.4242C18.9321 21.1415 19.5961 20.7091 20.1505 20.1548C20.7048 19.6005 21.1373 18.9365 21.42 18.2053C21.6906 17.5047 21.8798 16.7052 21.9314 15.5363C21.9829 14.363 21.9958 13.9891 21.9958 11.0022C21.9958 8.01527 21.9914 7.64137 21.94 6.46809ZM19.9588 15.4503C19.9114 16.5248 19.731 17.105 19.5805 17.4918C19.2109 18.4502 18.4502 19.2109 17.4918 19.5805C17.105 19.731 16.5206 19.9114 15.4503 19.9586C14.29 20.0103 13.942 20.023 11.0066 20.023C8.07118 20.023 7.71881 20.0103 6.56259 19.9586C5.48816 19.9114 4.90796 19.731 4.52117 19.5805C4.04425 19.4043 3.61014 19.1249 3.25772 18.7596C2.89242 18.4029 2.61306 17.9731 2.43677 17.4961C2.28635 17.1094 2.10589 16.5248 2.05874 15.4547C2.007 14.2943 1.99428 13.9461 1.99428 11.0107C1.99428 8.07535 2.007 7.72298 2.05874 6.56698C2.10589 5.49254 2.28635 4.91235 2.43677 4.52555C2.61306 4.04842 2.89241 3.61439 3.26211 3.26189C3.61865 2.89658 4.04842 2.61723 4.52555 2.44115C4.91235 2.29073 5.49692 2.11023 6.56697 2.06291C7.72736 2.01134 8.07556 1.99844 11.0107 1.99844C13.9505 1.99844 14.2985 2.01134 15.4547 2.06291C16.5292 2.11027 17.1093 2.29069 17.4961 2.44111C17.9731 2.61723 18.4072 2.89658 18.7596 3.26189C19.1249 3.61865 19.4042 4.04842 19.5805 4.52555C19.731 4.91235 19.9114 5.49671 19.9587 6.56698C20.0103 7.72736 20.0232 8.07535 20.0232 11.0107C20.0232 13.9461 20.0104 14.29 19.9588 15.4503Z"
                className="group-hover:fill-gold fill-white duration-300"
              />
              <path
                d="M11.0026 5.35054C7.88252 5.35054 5.35107 7.88182 5.35107 11.0021C5.35107 14.1223 7.88252 16.6536 11.0026 16.6536C14.1227 16.6536 16.6541 14.1223 16.6541 11.0021C16.6541 7.88182 14.1227 5.35054 11.0026 5.35054ZM11.0026 14.668C8.97844 14.668 7.33654 13.0264 7.33654 11.0021C7.33654 8.97774 8.97844 7.33609 11.0025 7.33609C13.0269 7.33609 14.6685 8.97774 14.6685 11.0021C14.6685 13.0264 13.0268 14.668 11.0026 14.668ZM18.1971 5.12706C18.1971 5.85569 17.6063 6.44646 16.8775 6.44646C16.1489 6.44646 15.5581 5.85569 15.5581 5.12706C15.5581 4.39833 16.1489 3.80774 16.8775 3.80774C17.6063 3.80774 18.1971 4.39829 18.1971 5.12706Z"
                className="group-hover:fill-gold fill-white duration-300"
              />
            </svg>
          </div>
        </a>
      </div>

      {/* Twitter */}
      <div className="social-button">
        <a
          href="https://x.com/scanglobal"
          target="_blank"
          rel="noopener noreferrer"
          className="relative w-10 h-10 sm:w-11 sm:h-11 rounded-full group flex items-center justify-center"
        >
          <div className="floater w-full h-full absolute top-0 left-0 bg-gold/10 backdrop-blur-md rounded-full duration-300 group-hover:-top-8 group-hover:shadow-2xl sm:group-hover:-top-8 sm:group-hover:shadow-2xl" />
          <div className="icon relative z-10 w-full h-full flex items-center justify-center border-2 border-gold rounded-full cursor-pointer">
            <svg
              fill="none"
              viewBox="0 0 22 22"
              height={20}
              width={16}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.8115 9.3155L20.8253 0H18.9263L11.9679 8.08852L6.41015 0H0L8.40433 12.2313L0 22H1.89914L9.24745 13.4583L15.1168 22H21.5269L12.811 9.3155H12.8115ZM10.2103 12.339L9.35878 11.1211L2.58343 1.42964H5.5004L10.9682 9.25094L11.8197 10.4689L18.9272 20.6354H16.0102L10.2103 12.3395V12.339Z"
                className="group-hover:fill-gold fill-white duration-300"
              />
            </svg>
          </div>
        </a>
      </div>

      {/* Facebook */}
      <div className="social-button">
        <a
          href="https://www.facebook.com/ScanGlobalHoldings"
          target="_blank"
          rel="noopener noreferrer"
          className="relative w-10 h-10 sm:w-11 sm:h-11 rounded-full group flex items-center justify-center"
        >
          <div className="floater w-full h-full absolute top-0 left-0 bg-gold/10 backdrop-blur-md rounded-full duration-300 group-hover:-top-8 group-hover:shadow-2xl sm:group-hover:-top-8 sm:group-hover:shadow-2xl" />
          <div className="icon relative z-10 w-full h-full flex items-center justify-center border-2 border-gold rounded-full cursor-pointer">
            <svg
              fill="none"
              viewBox="0 0 13 22"
              height={20}
              width={14}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.71289 22H4.1898C3.60134 22 3.12262 21.5213 3.12262 20.9328V12.9863H1.06717C0.478672 12.9863 0 12.5074 0 11.9191V8.514C0 7.9255 0.478672 7.44683 1.06717 7.44683H3.12262V5.74166C3.12262 4.05092 3.6535 2.6125 4.65773 1.58207C5.6665 0.546992 7.07627 0 8.7346 0L11.4214 0.00438281C12.0089 0.00537109 12.4868 0.484086 12.4868 1.07151V4.23311C12.4868 4.82157 12.0083 5.30028 11.4199 5.30028L9.61091 5.30093C9.05919 5.30093 8.91868 5.41153 8.88864 5.44543C8.83914 5.50172 8.78023 5.66062 8.78023 6.09954V7.4467H11.284C11.4725 7.4467 11.6551 7.49319 11.812 7.58076C12.1506 7.76995 12.3611 8.12762 12.3611 8.51417L12.3597 11.9193C12.3597 12.5074 11.881 12.9861 11.2926 12.9861H8.78019V20.9328C8.78023 21.5213 8.30139 22 7.71289 22ZM4.41233 20.7103H7.49031V12.4089C7.49031 12.016 7.81009 11.6964 8.20282 11.6964H11.07L11.0712 8.73662H8.20265C7.80991 8.73662 7.49031 8.41706 7.49031 8.02411V6.09959C7.49031 5.59573 7.54153 5.0227 7.92185 4.59198C8.38144 4.07133 9.10568 4.01126 9.61056 4.01126L11.1971 4.01057V1.29375L8.73357 1.28975C6.06848 1.28975 4.41238 2.99574 4.41238 5.7417V8.02407C4.41238 8.4168 4.09277 8.73658 3.7 8.73658H1.28975V11.6964H3.7C4.09277 11.6964 4.41238 12.016 4.41238 12.4089L4.41233 20.7103Z"
                className="group-hover:fill-gold fill-white duration-300"
              />
            </svg>
          </div>
        </a>
      </div>

      {/* LinkedIn */}
      <div className="social-button">
        <a
          href="https://www.linkedin.com/company/scanglobal/"
          target="_blank"
          rel="noopener noreferrer"
          className="relative w-10 h-10 sm:w-11 sm:h-11 rounded-full group flex items-center justify-center"
        >
          <div className="floater w-full h-full absolute top-0 left-0 bg-gold/10 backdrop-blur-md rounded-full duration-300 group-hover:-top-8 group-hover:shadow-2xl sm:group-hover:-top-8 sm:group-hover:shadow-2xl" />
          <div className="icon relative z-10 w-full h-full flex items-center justify-center border-2 border-gold rounded-full cursor-pointer">
            <svg
              fill="none"
              viewBox="0 0 22 22"
              height={20}
              width={20}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M20.447 20.452H16.893V14.845C16.893 13.492 16.868 11.782 15.006 11.782C13.116 11.782 12.845 13.236 12.845 14.749V20.452H9.293V8.999H12.693V10.561H12.74C13.211 9.675 14.237 8.743 15.771 8.743C19.102 8.743 20.448 10.771 20.448 13.684V20.452H20.447ZM5.337 7.433C4.119 7.433 3.137 6.449 3.137 5.233C3.137 4.017 4.119 3.033 5.337 3.033C6.554 3.033 7.537 4.017 7.537 5.233C7.537 6.449 6.554 7.433 5.337 7.433ZM7.119 20.452H3.553V8.999H7.119V20.452ZM21.447 0H0.553C0.247 0 0 0.247 0 0.553V21.447C0 21.753 0.247 22 0.553 22H21.447C21.753 22 22 21.753 22 21.447V0.553C22 0.247 21.753 0 21.447 0Z"
                className="group-hover:fill-gold fill-white duration-300"
              />
            </svg>
          </div>
        </a>
      </div>
    </div>
  );
};

export default SocialIcons;
